import React, { useState } from "react";
import truncate from "html-truncate";
import classes from "./FitnessPreview.module.scss";

function getLiInnerHtmls(html) {
  const div = document.createElement("div");
  div.innerHTML = html || "";
  return Array.from(div.querySelectorAll("li"))
    .map(li => {
      let h = li.innerHTML;
      // replace non-breaking spaces with normal spaces
      h = h.replace(/&nbsp;|&#160;/g, " ");
      // collapse multiple whitespace (spaces, tabs, newlines) to one
      h = h.replace(/\s+/g, " ");
      return h.trim();
    });
}

const MAX_CHARS = 190;

export default function ProgramHighlights({ highlights }) {
  const [expanded, setExpanded] = useState(false);

  const items = getLiInnerHtmls(highlights);
  const fullText = items.join("");
  const needsClipping = fullText.length > MAX_CHARS;

  let visible = items;
  if (needsClipping && !expanded) {
    const clippedBig = truncate(fullText, MAX_CHARS - 30, { ellipsis: "…" });
    let cum = 0;
    visible = [];
    for (let html of items) {
      const text = html.replace(/<[^>]+>/g, "");
      if (cum + text.length <= clippedBig.length) {
        visible.push(html);
        cum += text.length;
      } else {
        const remaining = clippedBig.slice(cum).trim();
        visible.push(remaining);
        break;
      }
    }
  }

  return (
    <div className={classes.sectionContainer}>
      <div className={classes.subheading}>Program Highlights</div>
      <ul className={classes.highlightsText}>
        {visible.map((html, i) => {
          const isLast = i === visible.length - 1 && (needsClipping || expanded);
          return (
            <li key={i}>
              <span dangerouslySetInnerHTML={{ __html: html }} />
              {/* Insert show less button within last list element to ensure inline */}
              {isLast && (
                <span
                  className={expanded ? classes.showLessBtn : classes.showMoreBtn}
                  onClick={() => setExpanded(x => !x)}
                  style={{ marginLeft: "0.3ch", cursor: "pointer" }}
                >
                  {expanded ? " Show less" : " Show more"}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

